import { createContext, useEffect, useState } from 'react';
import { surveys } from '../utils/surveys';
import { useSearchParams, useLocation } from 'react-router-dom';

export const AssessmentContext = createContext(null);

function AssessmentContextProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const tabParam = parseInt(searchParams.get('tab'));
  const [tabValue, setTabValue] = useState(0)

  useEffect(() => {
    if (location.pathname.startsWith('/client/')) {
      if (tabParam >= 0) {
        setTabValue(tabParam)
      } else {
        setTabValue(1)
      }
    } else {
      if (tabParam >= 0) {
        setTabValue(tabParam)
      } else {
        setTabValue(0)
      }
    }
  }, [tabParam, location.pathname])
  

  return (
    <AssessmentContext.Provider
      value={{
        tabValue,
        setTabValue
      }}
    >
      {children}
    </AssessmentContext.Provider>
  );
}

export default AssessmentContextProvider;
